import React from 'react'
import {
  Button, Icon, ListItemIcon, Typography,
} from '@mui/material'
import { withStyles } from 'tss-react/mui'
import classNames from 'classnames'
import { EcoModeDeviceIcon } from 'icons'
import { checkIconNumber } from '@app/helpers/myDevices/checkIconNumber'
import { devicesIcons } from '@app/lib/MyDevices/devicesIcons'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import styles from './EcoModeDevice.style'

interface Props {
  classes: Record<string, string>,
  className?: string,
  admin: boolean,
  id: number,
  icon: number,
  name: string,
  ecoModeStatus: boolean,
  selectCurrentEcoModeDeviceId: (id: number) => void,
  selectCurrentEcoModeDeviceStatus: (status: boolean) => void,
  patchCurrentEcoModeDevice: (...args: any[]) => void,
}

class EcoModeDevice extends React.Component<Props> {
  toggleEcoModeStatus = () => {
    const {
      id,
      ecoModeStatus,
      selectCurrentEcoModeDeviceId,
      selectCurrentEcoModeDeviceStatus,
      patchCurrentEcoModeDevice,
    } = this.props
    selectCurrentEcoModeDeviceId(id)
    selectCurrentEcoModeDeviceStatus(ecoModeStatus)
    patchCurrentEcoModeDevice()
  }

  render() {
    const {
      classes,
      icon,
      name,
      ecoModeStatus,
      admin,
    } = this.props
    return (
      <Wrapper className={classes.deviceItem}>
        <ListItemIcon>
          <Icon className={classes.deviceIcon}>{devicesIcons[checkIconNumber(icon)]}</Icon>
        </ListItemIcon>
        <Typography className={classes.deviceName}>{name}</Typography>
        <Button
          color="primary"
          className={classNames(ecoModeStatus ? classes.button : classes.buttonDisabled)}
          variant="contained"
          onClick={this.toggleEcoModeStatus}
          disabled={!admin}
        >
          <Wrapper className={classes.svgWrapper}>
            <EcoModeDeviceIcon className={classes.titleIcon} color={ecoModeStatus ? 'primary' : 'disabled'} />
          </Wrapper>
        </Button>
      </Wrapper>
    )
  }
}

export default withStyles(EcoModeDevice, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
